import { applyDashboardPrefsToDocument } from './dashboardPrefsApply';
import { readDashboardPrefsFromLocalStorage } from './dashboardPrefsStorage';

const AUTH_STORAGE_KEY = 'district88-auth';

/** Best-effort Supabase session user id before React / AuthProvider run (matches `storageKey` in supabase client). */
export function readSessionUserIdFromLocalStorage(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = window.localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as unknown;
    if (Array.isArray(parsed)) {
      for (const el of parsed) {
        if (el && typeof el === 'object' && 'user' in el) {
          const id = (el as { user?: { id?: string } }).user?.id;
          if (typeof id === 'string' && id.length >= 8) return id;
        }
      }
    }
    if (parsed && typeof parsed === 'object') {
      const o = parsed as Record<string, unknown>;
      const u =
        (o.user as { id?: string } | undefined)?.id ??
        (o.currentSession as { user?: { id?: string } } | undefined)?.user?.id ??
        (o.session as { user?: { id?: string } } | undefined)?.user?.id;
      if (typeof u === 'string' && u.length >= 8) return u;
    }
    return undefined;
  } catch {
    return undefined;
  }
}

/** Apply dashboard prefs to `<html>` as early as possible (first paint, including routes without PlatformLayout). */
export function bootstrapDashboardPrefsFromStorage(): void {
  if (typeof document === 'undefined') return;
  const uid = readSessionUserIdFromLocalStorage();
  const prefs = readDashboardPrefsFromLocalStorage(uid);
  applyDashboardPrefsToDocument(prefs);
}
